<!-- Action Button -->
<button
  mat-flat-button
  *ngIf="button.action"
  (click)="emitHeaderEvent.emit(button.action || null)"
  [color]="button.color"
  [class]="button.style + ' standard-button'"
  options-id="HEADER_BUTTON"
  [option]="constantize(button.name)">
  <ng-container *ngIf="button.icon && hasIconPrefix(button)">
    <fa-icon
      *ngIf="button.icon"
      [icon]="[button.icon[0], button.icon[1]]" size="xl"
      [ngClass]="button.name ? 'iconSpace' : ''"
      ></fa-icon>
  </ng-container>
  <ng-container *ngIf="button.icon && !hasIconPrefix(button)">
    <fa-icon *ngIf="button.icon" [icon]="['fas', button.icon]" size="xl" [ngClass]="button.name ? 'iconSpace' : ''"></fa-icon>
  </ng-container>
  {{ button.name | uppercase }}
</button>

<!-- Internal Route Button -->
<button
  mat-flat-button
  *ngIf="button.normalizedRoute && !button.isExternalRoute"
  [routerLink]="button.normalizedRoute"
  [queryParamsHandling]="button.queryParamsHandling || null"
  [color]="button.color"
  [class]="button.style + ' standard-button'"
  options-id="HEADER_BUTTON"
  [option]="constantize(button.name)">
  <ng-container *ngIf="button.icon && hasIconPrefix(button)">
    <fa-icon
      *ngIf="button.icon"
      [icon]="[button.icon[0], button.icon[1]]" size="xl"
      [ngClass]="button.name ? 'iconSpace' : ''"
      ></fa-icon>
  </ng-container>
  <ng-container *ngIf="button.icon && !hasIconPrefix(button)">
    <fa-icon *ngIf="button.icon" [icon]="['fas', button.icon]" size="xl" [ngClass]="button.name ? 'iconSpace' : ''"></fa-icon>
  </ng-container>
  {{ button.name }}
</button>

<!-- External Route Button -->
<button
  mat-flat-button
  *ngIf="button.normalizedRoute && button.isExternalRoute"
  target="_blank"
  [color]="button.color"
  [class]="button.style + ' standard-button'"
  options-id="HEADER_BUTTON"
  [option]="constantize(button.name)">
  <ng-container *ngIf="button.icon && hasIconPrefix(button)">
    <fa-icon
      *ngIf="button.icon"
      [icon]="[button.icon[0], button.icon[1]]"></fa-icon>
  </ng-container>
  <ng-container *ngIf="button.icon && !hasIconPrefix(button)">
    <fa-icon *ngIf="button.icon" [icon]="['fas', button.icon]"></fa-icon>
  </ng-container>
  <a [href]="button.normalizedRoute">{{ button.name }}</a>
</button>

<!-- Dropdown Button Group -->
<button
  mat-flat-button
  *ngIf="button.dropdownOptions"
  type="button"
  [color]="button.color"
  [class]="button.style + ' standard-button'"
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
  options-id="HEADER_BUTTON"
  [option]="constantize(button.name)">
  <fa-icon *ngIf="button.icon" [icon]="['fas', button.icon]"></fa-icon>
  {{ button.name }}
</button>
<div class="dropdown-menu">
  <ng-container *ngFor="let dropdownButton of button.dropdownOptions">
    <!-- Action Button -->
    <button
      *ngIf="dropdownButton.action"
      (click)="emitHeaderEvent.emit(dropdownButton.action || null)"
      [className]="dropdownButton.style + ' dropdown-item standard-button'"
      [options-id]="constantize(button.name) || constantize(button.action)"
      [option]="constantize(dropdownButton.name)">
      <ng-container
        *ngIf="dropdownButton.icon && hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="[dropdownButton.icon[0], dropdownButton.icon[1]]"></fa-icon>
      </ng-container>
      <ng-container
        *ngIf="dropdownButton.icon && !hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="['fas', dropdownButton.icon]"></fa-icon>
      </ng-container>
      {{ dropdownButton.name }}
    </button>

    <!-- Internal Route Button -->
    <a
      *ngIf="dropdownButton.normalizedRoute && !dropdownButton.isExternalRoute"
      [routerLink]="dropdownButton.normalizedRoute"
      [queryParamsHandling]="dropdownButton.queryParamsHandling || null"
      [className]="dropdownButton.style + ' dropdown-item standard-button'"
      [options-id]="constantize(button.name) || constantize(button.action)"
      [option]="constantize(dropdownButton.name)">
      <ng-container
        *ngIf="dropdownButton.icon && hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="[dropdownButton.icon[0], dropdownButton.icon[1]]"></fa-icon>
      </ng-container>
      <ng-container
        *ngIf="dropdownButton.icon && !hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="['fas', dropdownButton.icon]"></fa-icon>
      </ng-container>
      {{ dropdownButton.name }}
    </a>

    <!-- External Route Button -->
    <a
      *ngIf="dropdownButton.normalizedRoute && dropdownButton.isExternalRoute"
      [href]="dropdownButton.normalizedRoute"
      target="_blank"
      [className]="dropdownButton.style + ' dropdown-item standard-button'"
      [options-id]="constantize(button.name) || constantize(button.action)"
      [option]="constantize(dropdownButton.name)">
      <ng-container
        *ngIf="dropdownButton.icon && hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="[dropdownButton.icon[0], dropdownButton.icon[1]]"></fa-icon>
      </ng-container>
      <ng-container
        *ngIf="dropdownButton.icon && !hasIconPrefix(dropdownButton)">
        <fa-icon
          *ngIf="dropdownButton.icon"
          [icon]="['fas', dropdownButton.icon]"></fa-icon>
      </ng-container>
      {{ dropdownButton.name }}
    </a>
  </ng-container>
</div>
